import RedirectWithQuery from './RedirectWithQuery';

export default RedirectWithQuery;
